<template>
  <v-card>
    <v-card-title>
      <ent-workflow-nav-bar
        :args="wNav"
        :buttonclick.sync="navbuttons"
        :title="wTitle"
      ></ent-workflow-nav-bar>
    </v-card-title>
    <clone-plant-search></clone-plant-search>
    <v-card-text> </v-card-text>
  </v-card>
</template>
<script setup>
  // Components used in this view
  import EntWorkflowNavBar from "@/../../library/view/EntWorkflowNavBar.vue";
  import EntWorkflowWelcome from "@/../../library/view/EntWorkflowWelcome.vue";
  import EntSearchConfig from "@/../../library/view/EntSearchConfig.vue";
  import ClonePlantSearch from "@/../../cortex/src/views/ClonePlantSearch.vue"

  // Component functions
  import { useWorkflowController } from "@/../../library/compFunctions/useWorkflowController.js";
  import {
    fullSize,
    card800,
    fieldStyles,
  } from "@/../../library/compFunctions/useStyles.js";
  import {
    startToast,
    endToast,
  } from "@/../../cortex/src/compFunctions/useToasted.js";

  // Services used
  import {
    create,
    update,
    loadOneActive,
    findOne,
  } from "@/../../cortex/src/services/cortex.js";

  // Helper Functions
  import check from "@/../../library/helper/propertyCheck.js";
  const CONSTANTS = require("@/../../library/constants/server.js");
  import moment from "moment";

  // Vue helper functions
  import { onMounted, ref, watch, getCurrentInstance, computed } from "vue";

  // Define the properties
  const props = defineProps({ args: { type: Object, required: false } });

  // Define the emits of this flow
  const emit = defineEmits(["update:finished"]);

  // Get the VM instance - needed for some of the plugins
  const vm = getCurrentInstance();
  console.log(`******** VM = `, vm);

  // Prepare the workflow configuration based on the controller properties
  const {
    config: wNav,
    mode: mode,
    hero: heroPanel,
    search: searchPanel,
    main: mainPanel,
  } = useWorkflowController();

  let wTitle = ref("");

  // Set the default behavior of the panel
  onMounted(() => {
    console.log(`%%%% Plant Cloning Mounted`)
    wTitle.value = props.args?.title
  })

  // Create the variable to handle the navigation bar button clicks
  const navbuttons = ref(null)
</script>
